import React from 'react'

export default function ProjectGif() {
    return (
        <div className='project-embed'>
            
            <div className='banner'>
                RE-CONNECT
            </div>
            <div className='box-gif'>
                
            </div>
            <div className='box-text'>
            Softwares Used: AI, AE <br /><br />
Made as an entry for the 2021 Motion Graphics MODE Festival with the theme of ‘reconnection’, this work takes a spiritual interpretation on reconnection. While most people used visuals of technology and human reconnection, I mixed the visual of an electric outlet connecting a persons head to their body, symbolizing a more spiritual reconnection with oneself. This project was designed in Illustrator and animated in After Effects.
            </div>
        </div>
    )
}
